import React from "react";
import { useTranslation } from "react-i18next";
import { InsertLinkIcon, ListItem } from "@activecollab/components";
import PropTypes from "prop-types";
import { showSuccessToast, showErrorToast } from "../Toast";

export const InsertLinkListItem = ({ link, onCopy }) => {
  const { t } = useTranslation();

  const handleCopyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(link);
      showSuccessToast(t("Link copied to clipboard."));
      if (typeof onCopy === "function") onCopy();
    } catch (err) {
      showErrorToast(t(err.message));
    }
  };

  return (
    <ListItem onClick={handleCopyToClipboard}>
      <InsertLinkIcon className="tw-fill-theme-900" />
      {t("Copy Link")}
    </ListItem>
  );
};

InsertLinkListItem.propTypes = {
  link: PropTypes.string,
  onCopy: PropTypes.func,
};
